import { render } from "./SettingsJobs.vue?vue&type=template&id=aad5905c&scoped=true"
import script from "./SettingsJobs.vue?vue&type=script&lang=js"
export * from "./SettingsJobs.vue?vue&type=script&lang=js"

import "./SettingsJobs.vue?vue&type=style&index=0&id=aad5905c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad5905c"]])

export default __exports__